import { atom, useAtom } from "jotai";
import useStore from "../../../../../../../../../../../context/useStore";
import tools from "../../../../../../../../../../../helpers/tools";

const receiptAtom = atom(null);

const useReceiptItem = () => {
  const [state] = useStore();
  const { PAYMENT_STATUS } = state.constants.items;
  const [receipt, setReceipt] = useAtom(receiptAtom);
  const receiptStatusRef = tools.findIn(
    PAYMENT_STATUS,
    receipt?.payments?.status,
    "id"
  );

  const initReceipt = (receiptData) => {
    setReceipt(receiptData);
  };

  const onUpdateReceipt = (newReceipt) => {
    setReceipt(newReceipt);
  };

  return {
    PAYMENT_STATUS,
    receipt,
    receiptStatusRef,
    initReceipt,
    onUpdateReceipt,
  };
};

export default useReceiptItem;
